import React from 'react';
import {useStoreState} from 'easy-peasy';
import EventsListView from '@/views/events/EventsListView';

interface TeamEventsViewProps {
    teamId?: string;
}

const TeamEventsView: React.FC<TeamEventsViewProps> = React.memo(({teamId}) => {
    const activeStoryObject = useStoreState((state: any) => state.activeStoryObject.activeStoryObject);

    return (
        <>
            <EventsListView
                activeObject={teamId || activeStoryObject}
                activeObjectType="team"
            />
        </>
    );
});

export default TeamEventsView;